import { memo } from "react";

import styles from "./RebateProgressItem.module.css";
import {
    type ICashbackLevel,
    type IUserProgress
} from "features/campaigns/_exports";
import { getLevelFillPercent, isCurrentLevel, isLevelUnlocked } from "../../../../utils/variants/rebateHelpers";

interface RebateProgressItemProps {
    cashbackLevel: ICashbackLevel
    userProgress: IUserProgress | null
    variant: 'card' | 'winnings-tab'
}

const RebateProgressItem: React.FC<RebateProgressItemProps> = ({ cashbackLevel, variant, userProgress }) => {
    const fillPercentage = getLevelFillPercent(userProgress, cashbackLevel);
    const spentAmount = userProgress?.spentBetAmount;
    const isUnlocked = isLevelUnlocked(spentAmount, cashbackLevel);
    const isCurrent = isCurrentLevel(spentAmount, cashbackLevel);

    return (
        <div className={styles.progressItemContainer} data-variant={variant}>
            {
                fillPercentage > 0 && (
                    <div
                        className={styles.progressItemFill}
                        data-percent={fillPercentage}
                        data-is-unlocked={isUnlocked}
                        data-is-current={isCurrent}
                        style={{ width: `calc(${fillPercentage}% + 2 * var(--progress-item-border))` }}
                    >
                    </div>
                )
            }
        </div >
    );
};

export default memo(RebateProgressItem);